import {
  Arrange,
  Container,
  Spacer,
  SvgChrome,
  Text,
  TextButton,
} from '@loomhq/lens';
import classnames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';

import {
  DOWNLOAD_BANNER_DESKTOP_APP_INSTALL_CLICKED,
  DOWNLOAD_BANNER_EXTENSION_INSTALL_CLICKED,
} from 'constants/events';
import { CHROME_EXT_WEBSTORE_URL } from 'constants/routes';
import {
  selectCurrentUser,
  selectUserHasUsedDesktop,
  selectUserHasUsedExtension,
} from 'selectors/user';
import * as analytics from 'utilities/analytics';
import {
  getSupportedPlatformType,
  isSupportedDesktopPlatform,
} from 'utilities/download-desktop';

import DownloadDesktopButton, {
  BUTTON_TYPE_TEXT,
} from 'components/download-desktop-button';

import styles from './styles.module.less';

const MAX_ACCOUNT_AGE = 28; // do not show this banner for accounts older than this many days

const RecorderDownloadBanner = () => {
  const hasDesktopApp = useSelector(selectUserHasUsedDesktop);
  const hasExtension = useSelector(selectUserHasUsedExtension);
  const user = useSelector(selectCurrentUser);

  const platform = getSupportedPlatformType();

  const isNewAccount = () => {
    const startDate = new Date();
    const accountCreated = new Date(user.createdAt);

    startDate.setDate(startDate.getDate() - MAX_ACCOUNT_AGE);

    return accountCreated >= startDate;
  };

  const showBanner = !hasDesktopApp && !hasExtension && isNewAccount();

  if (!showBanner) {
    return null;
  }

  return (
    <Container
      backgroundColor="offWhite"
      radius="medium"
      paddingTop="medium"
      paddingRight="large"
      paddingBottom="medium"
      paddingLeft="large"
      className={classnames('mt:medium mr:medium ml:medium', styles.banner)}
    >
      <div className="flex items:center">
        <div className="grow:1">
          <Arrange align="center" gap="medium">
            <Text>🎥</Text>
            <Text>
              <strong>Download Loom</strong> to record anywhere at anytime.
            </Text>
          </Arrange>
        </div>
        <div className="flex items:center">
          {isSupportedDesktopPlatform && (
            <Spacer right="medium">
              <DownloadDesktopButton
                buttonType={BUTTON_TYPE_TEXT}
                afterOnClick={() => {
                  analytics.track(DOWNLOAD_BANNER_DESKTOP_APP_INSTALL_CLICKED, {
                    platform,
                  });
                }}
              />
            </Spacer>
          )}
          <TextButton
            icon={<SvgChrome />}
            onClick={() => {
              analytics.track(DOWNLOAD_BANNER_EXTENSION_INSTALL_CLICKED);
              document.location = CHROME_EXT_WEBSTORE_URL;
            }}
          >
            Install Chrome extension
          </TextButton>
        </div>
      </div>
    </Container>
  );
};

export default RecorderDownloadBanner;
